import {
  BusinessSectionType,
  AvatarAndNameEmployeeType,
  AttachFileType,
  QuestionTypeType,
  BusinessDivisionType,
  PublicStatusType,
} from "~/domains";

export type EmployeeConditionSurveyType = {
  id: string;
  createdEmployee: AvatarAndNameEmployeeType;
  title: string;
  description?: string;
  startDate: string;
  endDate?: string;
  answerShareOption: EmployeeConditionSurveyAnswerShareOptionType;
  selectedSurveyTemplate: EmployeeConditionSurveyTemplateType;
  allBusinessSectionsDistribution: boolean;
  businessSections: BusinessSectionType[];
  businessDivisions: BusinessDivisionType[];
  publicStatus: PublicStatusType;
  createdAt: string;
  updatedAt: string;
};

export type EmployeeConditionSurveyWithQuestionsType =
  EmployeeConditionSurveyType & {
    questions: EmployeeConditionSurveyQuestionType[];
  };

export type EmployeeConditionSurveyQuestionType = {
  id: string;
  employeeConditionSurveyId: string;
  questionType: QuestionTypeType;
  question: string;
  file?: AttachFileType;
  displayOrder: number;
  required: boolean;
  options?: EmployeeConditionSurveyQuestionOptionType[];
  createdAt: string;
  updatedAt: string;
};

export type EmployeeConditionSurveyQuestionOptionType = {
  id: string;
  surveyQuestionId: string;
  option: string;
  point: number;
  file: AttachFileType;
  createdAt: string;
  updatedAt: string;
};

export type EmployeeConditionSurveyTemplateType = {
  id: number;
  name: string;
  key: string;
  questions: EmployeeConditionSurveyTemplateQuestionType[];
};

export type EmployeeConditionSurveyTemplateQuestionType = {
  id: number;
  name: string;
  type: "RADIO_BUTTON" | "TEXT_AREA";
  required: boolean;
  options?: EmployeeConditionSurveyTemplateQuestionOptionType[];
};

export type EmployeeConditionSurveyTemplateQuestionOptionType = {
  id: number;
  name: string;
  point?: number;
  value?: string;
  icon: string;
};

export const EmployeeConditionSurveyAnswerShareOptions = {
  MANAGER_AND_OWNER: {
    id: 1,
    name: "オーナーとマネージャーに共有",
    type: "manager_and_owner",
  },
  OWNER_ONLY: { id: 10, name: "オーナーに共有", type: "owner_only" },
} as const;

export type EmployeeConditionSurveyAnswerShareOptionType =
  (typeof EmployeeConditionSurveyAnswerShareOptions)[keyof typeof EmployeeConditionSurveyAnswerShareOptions];

export type EmployeeConditionSubmissionAnswerType = {
  id: string;
  employeeConditionSubmissionId: string;
  employeeConditionSurveyQuestionId: string;
  employeeConditionSurveyQuestionOptionId?: string;
  answer?: string;
  file?: string;
  createdAt: string;
  updatedAt: string;
};

export type EmployeeConditionSurveysDailyAnswer = {
  date: string; // ISO8601想定 (例: "2025-08-01")
  selectedOptionId?: number;
  selectedOptionLabel?: string;
  selectedOptionPoint?: number;
  answerText?: string;
};

export type EmployeeConditionSurveysAnswer = {
  employee: AvatarAndNameEmployeeType;
  dailyAnswers: EmployeeConditionSurveysDailyAnswer[];
};

export type EmployeeConditionSurveysQuestionOption = {
  id: number;
  label: string;
  point: number;
  fileUrl?: string;
};

export type EmployeeConditionSurveysDailyAverage = {
  date: string; // 集計日
  averagePoint: number; // その日の平均ポイント
  count: number; // 平均算出に使われた回答数
};

export type EmployeeConditionSurveysQuestionWithAnswers = {
  id: number;
  question: string;
  questionTypeId: QuestionTypeType["id"];
  options: EmployeeConditionSurveysQuestionOption[];
  employeeAnswers: EmployeeConditionSurveysAnswer[];
  dailyAveragePoints: EmployeeConditionSurveysDailyAverage[];
};
